/* Share-рейл статьи: Telegram и X — обычные <a> с интент-URL (без JS),
   здесь только «скопировать ссылку» с короткой индикацией успеха. */
export default function share() {
    document.querySelectorAll("[data-copy-link]").forEach((btn) => {
        btn.addEventListener("click", () => {
            const url = btn.getAttribute("data-copy-link") || window.location.href;
            if (!navigator.clipboard) return;
            navigator.clipboard.writeText(url).then(() => {
                btn.classList.add("ok");
                setTimeout(() => btn.classList.remove("ok"), 1600);
            });
        });
    });
}
